// UI translations for this locale. Keys must match the es reference bundle —
// enforced by `npm run check:i18n` (scripts/check-i18n-parity.mjs).
export const de = {
  app: { name: 'bitutravel' },
  nav: {
    home: 'Start',
    search: 'Suchen',
    login: 'Anmelden',
    register: 'Registrieren',
    dashboard: 'Dashboard',
    reservas: 'Buchungen',
    equipo: 'Team',
    logout: 'Abmelden',
    legal: 'Rechtliches',
    legalNotice: 'Impressum',
    privacy: 'Datenschutzerklärung',
    cookies: 'Cookie-Richtlinie',
    terms: 'Allgemeine Geschäftsbedingungen',
    clientes: 'Kunden',
  },
  legal: {
    noticeTitle: 'Impressum',
    noticeBody:
      'Gemäß dem spanischen Gesetz 34/2002 (LSSI-CE) wird darauf hingewiesen, dass diese Website von bitutravel betrieben wird. Kontakt-E-Mail: legal@bitutravel.app. Mit der Nutzung der Website erlangen Sie den Status eines Nutzers und akzeptieren die vorliegenden Bedingungen.',
    privacyTitle: 'Datenschutzerklärung',
    privacyBody:
      'Wir verarbeiten Ihre Daten ausschließlich zur Verwaltung Ihres Kontos, Ihrer Buchungen und der nach spanischem Recht erforderlichen Rechnungsstellung (DSGVO und LOPDGDD). Wir geben Ihre Daten niemals zu kommerziellen Zwecken an Dritte weiter. Ihre Rechte auf Auskunft, Berichtigung, Löschung und Datenübertragbarkeit können Sie per E-Mail an privacy@bitutravel.app geltend machen.',
    cookiesTitle: 'Cookie-Richtlinie',
    cookiesBody:
      'bitutravel verwendet ausschließlich technisch notwendige Cookies: die Authentifizierungssitzung und Ihre Sprachpräferenz. Wir setzen keine Werbe- oder Tracking-Cookies von Drittanbietern ein.',
    termsTitle: 'Allgemeine Geschäftsbedingungen',
    termsBody:
      'Buchungen werden über die Plattform angefragt und unterliegen der Zustimmung des Eigentümers sowie der gewählten Stornierungsrichtlinie. Die Unternehmensrechnung wird gemäß spanischem Recht ausgestellt (geltende MwSt. und IRPF). bitutravel tritt als Vermittler zwischen dem anfragenden Unternehmen und dem Eigentümer der Unterkunft auf. Die angezeigten Preise enthalten keine MwSt. (21%); sie wird zum Buchungsgesamtbetrag hinzugerechnet.',
  },
  landing: {
    heroTitle: 'Corporate-Unterkünfte, ganz unkompliziert',
    heroSubtitle:
      'Finden Sie hochwertige Unterkünfte für mittelfristige Aufenthalte Ihrer Teams in ganz Spanien. Mit dem Vertrauen führender Unternehmen.',
    checkIn: 'Anreise',
    checkOut: 'Abreise',
    guests: 'Gäste',
    search: 'Suchen',
    featured: 'Ausgewählte Unterkünfte',
    featuredIn: 'Ausgewählt in {{city}}',
    guestsValue: '{{count}} Gäste',
    where: 'Wohin',
    when: 'Wann',
    who: 'Wer',
    searchDestinations: 'Reiseziele suchen',
    addDates: 'Reisedaten hinzufügen',
    addGuests: 'Gäste hinzufügen',
    howItWorks: 'So funktioniert es',
    step1Title: 'Suchen',
    step1Desc: 'Erkunden Sie geprüfte Unterkünfte in den wichtigsten Städten Spaniens.',
    step2Title: 'Buchen',
    step2Desc: 'Buchen Sie mittelfristige Aufenthalte für Ihre Teams zu Corporate-Konditionen.',
    step3Title: 'Einziehen',
    step3Desc: 'Ihr Team zieht ein. Wir kümmern uns um Rechnung und Reisendenabrechnung.',
    perNight: '/ Nacht',
    perNightPlusIva: '/ Nacht + MwSt.',
    comingSoon: 'Demnächst verfügbar',
    trustedBy: 'Sie vertrauen uns bereits',
    testimonialsTitle: 'Was unsere Kunden sagen',
    review1Text: 'Seit wir bitutravel nutzen, erhalten wir die Rechnungen automatisch und der gesamte Prozess ist einfacher.',
    review1Author: 'María López',
    review1Role: 'Mobilitätsverantwortliche, Technologieberatung',
    review2Text: 'Wir verwalten die Unterkünfte des ganzen Teams auf einer Plattform. Die Zeit- und Kostenersparnis ist spürbar.',
    review2Author: 'Javier Ruiz',
    review2Role: 'Betriebsleiter, Ingenieurbüro',
    review3Text: 'Unternehmensrechnung und Reisekostenbericht kommen auditierfertig. Kein Verwaltungsaufwand.',
    review3Author: 'Elena García',
    review3Role: 'Finanzverantwortliche, multinational',
    illustrativeImage: 'Illustratives Bild',
  },
  search: {
    allSpain: 'Ganz Spanien',
    allDistricts: 'Alle Bezirke',
    viewAllResults: 'Alle Ergebnisse ansehen',
    results: 'Ergebnisse',
    sort: 'Sortieren',
    sortPriceAsc: 'Preis: aufsteigend',
    sortPriceDesc: 'Preis: absteigend',
    noResults: 'In dieser Gegend gibt es keine Unterkünfte.',
    noResultsForFilters:
      'Für diese Filter gibt es keine Unterkünfte. Entfernen Sie Reisedaten oder ändern Sie die Filter.',
    clearFilters: 'Filter zurücksetzen',
    areaPlaceholder: 'Stadtteil, Bereich oder PLZ',
    showMap: 'Karte',
    showMore: 'Mehr anzeigen',
    backToTop: 'Nach oben',
    typeAll: 'Alle',
    placeEntire: 'Ganze Wohnung',
    placeRoom: 'Privatzimmer',
    placeHotel: 'Hotel',
    dates: 'Datum',
    sortRecommended: 'Empfohlen',
    size: 'Schlafzimmer',
    sizeAny: 'Alle',
    sizeSingle: '1 Schlafzimmer',
    sizeDouble: '2 Schlafzimmer',
    size3plus: '3+ Schlafzimmer',
    rooms: 'Schlafzimmer',
    units: 'Einheiten',
    grouping: 'Gruppieren',
    groupAny: 'Beliebig',
    typeInCity: '{{type}} in {{city}}',
    forNights: 'für {{count}} Nächte',
    filters: 'Filter',
    groupSameBuilding: 'Gleiches Gebäude',
    groupSameArea: 'Nächstgelegene Zone',
    groupSameCategory: 'Gleiche Kategorie',
    roomsValue: '{{count}} Zi.',
    unitsValue: '{{count}} Eh.',
    groupResults: 'Gruppen',
    fromPrice: 'ab {{price}}',
    unitsInBuilding: '{{count}} Wohnungen in diesem Gebäude',
    groupUnits: 'Einheiten',
    sameBuilding: 'Gleiches Gebäude',
    sameArea: 'Nächstgelegene Zone',
    sameCategory: 'Gleiche Kategorie',
    anyGroup: 'Einheiten',
    priceFrom: 'ab',
    bookAll: 'Alle {{count}} buchen',
    playTour: 'Tour abspielen',
    approxMapNote: 'Lagen sind ungefähr. Melde dich an, um die genaue Lage zu sehen.',
    pauseTour: 'Tour pausieren',
    bookAllTitle: 'Gruppe buchen',
    bookAllDesc: 'Buchen Sie alle {{count}} Einheiten als ein gemeinsames Paket.',
    bookAllSummary: '{{count}} Einheiten · {{nights}} Nächte',
    bookAllSomeFailed: 'Einige Einheiten konnten nicht gebucht werden.',
    bookAllDone: 'Gruppe gebucht ({{ok}}/{{count}}).',
    structRoomIn: 'Zimmer in {{building}}',
    structRoomsSameApartment: '{{count}} Zimmer in derselben Wohnung',
    structRoomsSameBuilding: '{{count}} Zimmer im selben Gebäude',
    structApartmentsSameBuilding: '{{count}} Wohnungen im selben Gebäude',
    structStaysSameArea: '{{count}} Unterkünfte in derselben Gegend',
    structStaysSameCategory: '{{count}} Unterkünfte · {{category}}',
    structUnits: '{{count}} Einheiten',
    specFull: '{{guests}} Gäste · {{bedrooms}} Schlafzimmer · {{baths}} Bäder',
    specShort: '{{bedrooms}} SZ · {{baths}} Bad',
  },
  detail: {
    guests: 'Gäste',
    bedrooms: 'Schlafzimmer',
    bathrooms: 'Badezimmer',
    amenities: 'Ausstattung',
    location: 'Lage',
    nights: 'Nächte',
    cleaningFee: 'Reinigung',
    total: 'Gesamt',
    iva: 'MwSt. ({{pct}}%)',
    ivaNote: 'Preise ohne MwSt.: 21% MwSt. werden zum Buchungsgesamtbetrag hinzugerechnet. Vorschriftsgemäße Unternehmensrechnung.',
    bookNow: 'Jetzt buchen',
    loginToBook: 'Zum Buchen anmelden',
    signInForDetails: 'Melden Sie sich an, um alle Details zu sehen.',
    approxLocation: 'Ungefähre Lage (Radius ca. 700 m)',
    checkin: 'Anreise',
    checkout: 'Abreise',
    tooManyGuests: 'Diese Unterkunft bietet Platz für bis zu {{capacity}} Gäste.',
    minStayWarning: 'Mindestaufenthalt: {{count}} Nacht | Mindestaufenthalt: {{count}} Nächte',
    nightsWithCount: '{{count}} Nacht | {{count}} Nächte',
  },
  booking: {
    title: 'Jetzt buchen',
    subtitle: 'Prüfen Sie die Angaben des Reisenden. Der Betrag wird auf dem Server neu berechnet.',
    confirm: 'Buchung bestätigen',
    guestName: 'Name des Reisenden',
    guestNamePlaceholder: 'Vor- und Nachname',
    guestNif: 'NIF des Reisenden',
    datesRequired: 'Bitte wählen Sie gültige Reisedaten',
    nameRequired: 'Bitte geben Sie den Namen des Reisenden ein',
    nifInvalid: 'Ungültige NIF',
    requestCreated: 'Buchung erstellt. Zahlung ausstehend.',
    notAvailable: 'Diese Reisedaten sind nicht mehr verfügbar.',
    notApproved: 'Ihr Konto ist nicht für Buchungen freigegeben.',
    createError: 'Die Buchung konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
    awaitingDesc: 'Buchung erstellt. Führen Sie die Zahlung durch, um sie zu bestätigen.',
    totalWithIva: 'Gesamt (inkl. MwSt.)',
    priceEstimateNote: 'Schätzwert: den Endbetrag berechnet bitutravel bei der Buchung.',
    total: 'Gesamt',
    reference: 'Referenz',
    openPaymentLink: 'Zahlungslink öffnen',
    mockDevNote:
      'Entwicklermodus: Die Zahlung wird simuliert. Klicken Sie, um als bezahlt zu markieren und den Revolut-Webhook zu simulieren.',
    markPaidDev: 'Als bezahlt markieren (dev)',
    markPaidError: 'Die Zahlung konnte nicht simuliert werden.',
    paid: 'Zahlung bestätigt',
    paidDesc: 'Ihre Buchung ist bestätigt. Sie erhalten die Rechnung per E-Mail.',
    viewBookings: 'Meine Buchungen ansehen',
    paymentStatus: 'Zahlung',
    bookingsTitle: 'Meine Buchungen',
    browseStays: 'Unterkunft finden',
    summaryTotal: 'Buchungen',
    summaryUpcoming: 'Anstehend',
    summaryInstay: 'Im Aufenthalt',
    summarySpend: 'Gesamtausgabe',
    summaryPendingNote: 'Du hast {{count}} Buchungen mit offenem Zahlungseingang.',
    payStatusPaid: 'Bezahlt',
    payStatusPending: 'Ausstehend',
    payStatusAwaiting: 'Zahlung ausstehend',
    payStatusRefunded: 'Erstattet',
    payStatusFailed: 'Fehlgeschlagen',
    payStatusScheduled: 'Geplant',
    empty: 'Sie haben noch keine Buchungen.',
    statusAwaitingPayment: 'Zahlung ausstehend',
    statusConfirmed: 'Bestätigt',
    statusActive: 'Laufend',
    statusCompleted: 'Abgeschlossen',
    statusCancelled: 'Storniert',
    statusDisputed: 'Strittig',
    notFound: 'Buchung nicht gefunden.',
    viewProperty: 'Unterkunft ansehen',
    cleaningFee: 'Reinigung',
    platformFee: 'bitutravel-Gebühr',
    cancelBooking: 'Buchung stornieren',
    cancelConfirm:
      'Möchten Sie diese Buchung wirklich stornieren? Diese Aktion kann nicht rückgängig gemacht werden.',
    cancelConfirmYes: 'Ja, stornieren',
    cancelledToast: 'Buchung storniert.',
    cancelError: 'Die Buchung konnte nicht storniert werden.',
    cancelReason: 'Grund der Stornierung',
    copyLink: 'Link kopieren',
    tabFuture: 'Anstehend',
    tabPresent: 'Aktuell',
    tabPast: 'Vergangen',
    emptyTab: 'Keine Buchungen in diesem Bereich.',
    purpose: 'Reisezweck',
    purposeLeisure: 'Privat',
    purposeConference: 'Konferenz / Event',
    purposeProject: 'Projekt',
    purposeRelocation: 'Umzug',
    purposeOther: 'Sonstiges',
    eventName: 'Eventname',
    eventNamePlaceholder: 'z. B. Mobile World Congress 2026',
    teamSize: 'Reisende',
    teamNotes: 'Teamdetails',
    teamNotesPlaceholder: 'Reisende Namen, Zimmer, Notizen…',
    teamDetails: 'Reise- / Teamdetails',
    employee: 'Mitarbeiter',
    employeePlaceholder: 'Nicht zugewiesen',
    employeeNone: 'Kein Mitarbeiter',
    employeeFilterAll: 'Alle Mitarbeiter',
    employeeCardTitle: 'Zugewiesener Mitarbeiter',
  },
  team: {
    title: 'Team',
    addEmployee: 'Mitarbeiter hinzufügen',
    intro: 'Verwalte die Mitarbeiter deines Unternehmens. Weise sie Buchungen zu, damit sie die Reisedaten per E-Mail erhalten, oder aktiviere sie für eigene Buchungen auf Unternehmenskosten.',
    featureRosterTitle: 'Mitarbeiterliste',
    featureRosterDesc: 'Name, E-Mail, Telefon und NIF jedes Mitarbeiters. Die meisten sind wiederkehrend: wiederverwendbar über Buchungen.',
    featureEmailTitle: 'Details per E-Mail',
    featureEmailDesc: 'Bei Buchung den Mitarbeiter zuweisen — er erhält die Aufenthaltsdaten per E-Mail.',
    featureActivateTitle: 'Zum Buchen aktivieren',
    featureActivateDesc: 'Aktiviere einen Mitarbeiter, damit er sich mit eigener E-Mail einloggt und für das Unternehmen bucht.',
    empty: 'Noch keine Mitarbeiter. Bald kannst du sie hinzufügen und Buchungen zuweisen.',
    editEmployee: 'Mitarbeiter bearbeiten',
    editDesc: 'Kontaktdaten des Mitarbeiters aktualisieren.',
    addDesc: 'Mitarbeiter hinzufügen und aktivieren, damit er sich mit eigener E-Mail anmeldet.',
    addNote: 'Der Mitarbeiter wird zur Liste hinzugefügt. Damit er sich mit eigener E-Mail anmeldet, aktivieren Sie danach seinen Login.',
    activateLogin: 'Login aktivieren',
    alreadyActivated: 'Dieser Mitarbeiter hat bereits Login-Zugriff.',
    platformUnavailable: 'Der Dienst ist gerade nicht verfügbar. Versuchen Sie es später.',
    phone: 'Telefon',
    updated: 'Mitarbeiter aktualisiert.',
    added: 'Mitarbeiter hinzugefügt.',
    emailExists: 'Ein Mitarbeiter mit dieser E-Mail existiert bereits.',
    activated: 'Mitarbeiter aktiviert.',
    deactivated: 'Mitarbeiter deaktiviert.',
    deleted: 'Mitarbeiter gelöscht.',
    activate: 'Aktivieren',
    deactivate: 'Deaktivieren',
    delete: 'Löschen',
    deleteTitle: 'Mitarbeiter löschen',
    deleteConfirm: 'Möchten Sie {{name}} wirklich löschen? Das Konto wird entfernt und kann nicht wiederhergestellt werden.',
    statusActive: 'Aktiv',
    statusInactive: 'Inaktiv',
    statusRoster: 'Nur Liste',
    tempPwTitle: 'Temporäres Passwort',
    tempPwDesc: 'Dies ist das temporäre Passwort von {{name}}. Teilen Sie es sicher mit der Person.',
    tempPwWarn: 'Es wird nicht wieder angezeigt. Kopieren Sie es jetzt.',
    copy: 'Kopieren',
    copied: 'Kopiert',
  },
  agency: {
    title: 'Kunden',
    intro: 'Verwalten Sie die Kundenunternehmen Ihrer Agentur. Fügen Sie sie mit ihrer Rechnungs-E-Mail hinzu und buchen Sie Reisen in ihrem Namen — die Rechnung geht an das Kundenunternehmen.',
    addClient: 'Kundenunternehmen hinzufügen',
    clientEmail: 'Rechnungs-E-Mail des Unternehmens',
    clientEmailPlaceholder: 'rechnungen@firma.de',
    addNote: 'Das Unternehmen muss ein bitutravel-Konto haben und freigegeben sein. Wird beim Verknüpfen geprüft.',
    empty: 'Sie haben noch keine Kundenunternehmen. Fügen Sie eins hinzu, um in seinem Namen zu buchen.',
    client: 'Kunde',
    unknownClient: 'Kundenunternehmen',
    unlinkConfirm: 'Möchten Sie {{name}} wirklich trennen? Sie können dann nicht mehr in seinem Namen buchen.',
    unlinkedBtn: 'Trennen',
    unlinked: 'Kundenunternehmen getrennt.',
    linked: 'Kundenunternehmen verknüpft: {{name}}.',
    notFound: 'Kein freigegebenes Unternehmen mit dieser E-Mail gefunden.',
    billTo: 'Buchen für',
    selectClient: 'Kundenunternehmen auswählen',
    noClientsWarn: 'Fügen Sie zuerst ein Kundenunternehmen unter Kunden hinzu, um buchen zu können.',
  },

  invoices: {
    title: 'Rechnungen & Reisendenabrechnungen',
    backToBookings: '← Meine Buchungen',
    count: 'Rechnungen',
    baseTotal: 'Nettobasis',
    ivaTotal: 'MwSt.',
    irpfTotal: 'IRPF einbehalten',
    total: 'Fakturierte Gesamtsumme',
    invoicesTitle: 'Rechnungen',
    ref: 'Buchung',
    parteTitle: 'Reisendenabrechnungen',
    parteEmpty: 'Noch keine Reisendenabrechnungen.',
    empty:
      'Sie haben noch keine Rechnungen. Sie werden automatisch bei Bestätigung einer Buchung erstellt.',
    regenTitle: 'Dokumente neu ausstellen',
    regenDesc:
      'Erstellt die Rechnung und die Reisendenabrechnung einer Buchung neu (nützlich für die Buchhaltung).',
    regenDone: 'Dokumente neu erstellt.',
    regenError: 'Die Dokumente konnten nicht neu erstellt werden.',
    downloadError: 'Das Dokument konnte nicht heruntergeladen werden.',
    navInvoices: 'Rechnungen',
    period30: 'Letzte 30 Tage',
    period90: 'Letzte 90 Tage',
    period365: 'Letzte 12 Monate',
    periodAll: 'Gesamter Zeitraum',
    periodEmpty: 'In diesem Zeitraum gibt es keine Rechnungen.',
    exportCsv: 'CSV exportieren',
    exportZip: 'PDFs herunterladen (ZIP)',
    statusIssued: 'Ausgestellt',
    statusPaid: 'Bezahlt',
    statusVoid: 'Annulliert',
  },
  owner: {
    calendar: {
      title: 'Preiskalender',
      subtitle: 'Preis, Mindestaufenthalt und Verfügbarkeit Nacht für Nacht',
      navButton: 'Preise',
      backendRequired: 'Konfiguriere das Supabase-Backend, um den Preiskalender zu nutzen.',
      basePrice: 'Basispreis',
      cleaningFee: 'Reinigung',
      applyTitle: 'Auf Auswahl anwenden',
      clearSelection: 'Auswahl aufheben',
      selectHint: 'Klicke auf eine Nacht und dann auf eine weitere, um einen Zeitraum auszuwählen. Jede Zelle ist eine Nacht — die letzte markierte ist die Nacht vor dem Check-out.',
      selectedNights: '{{count}} Nacht ausgewählt | {{count}} Nächte ausgewählt',
      skipped: '{{count}} Nacht übersprungen (gebucht oder vorbei) | {{count}} Nächte übersprungen (gebucht oder vorbei)',
      noneEditable: 'Alle ausgewählten Nächte sind bereits gebucht oder liegen in der Vergangenheit.',
      priceLabel: 'Neuer Preis (€)',
      pricePlaceholder: '€ / Nacht',
      minNightsLabel: 'Mindestaufenthalt (Nächte)',
      minNightsPlaceholder: 'z. B. 5',
      applyPrice: 'Preis festlegen',
      applyMinNights: 'Minimum festlegen',
      block: 'Sperren',
      unblock: 'Öffnen',
      removeOverride: 'Anpassung entfernen',
      blockNameLabel: 'Sperrname',
      blockNamePlaceholder: 'z. B. Wartung, Renovierung…',
      saved: 'Kalender aktualisiert',
      saveError: 'Kalender konnte nicht gespeichert werden.',
      legend: {
        available: 'Verfügbar',
        priced: 'Sonderpreis',
        blocked: 'Gesperrt',
        booked: 'Gebucht',
        past: 'Vergangen',
        sunday: 'Sonntag',
      },
      ical: {
        title: 'Kalender exportieren (iCal)',
        desc: 'Verknüpfe diesen Feed mit Airbnb, Booking.com oder deinem Channel Manager, um Buchungen zu synchronisieren.',
        copy: 'Kopieren',
        copied: 'Link kopiert',
        unavailable: 'Feed für diese Unterkunft nicht verfügbar.',
      },
      bulk: {
        from: 'Von',
        to: 'bis',
        allDays: 'Alle Tage',
        weekdays: 'Werktage',
        weekends: 'Wochenende',
        allYear: 'Ganzes Jahr',
        pickDay: 'Wählen Sie mindestens einen Wochentag',
      },
    },
    revenueTitle: 'Einnahmen',
    invoicesTitle: 'Rechnungen & Auszahlungen',
    invoicesNote: 'Rechnungen werden bei Buchungsbestätigung automatisch erzeugt; Auszahlungen erfolgen nach bitutravel-Zeitplan.',
    gross: 'Nettobasis (o. MwSt.)',
    fee: 'bitutravel-Gebühr',
    iva: 'MwSt.',
    net: 'Nettoeinnahmen',
    paidOut: 'Ausgezahlt',
    pending: 'Auszahlung ausstehend',
    monthlyTitle: 'Einnahmen pro Monat',
    perPropertyTitle: 'Nach Unterkunft',
    property: 'Unterkunft',
    bookings: 'Buchungen',
    nights: 'Nächte',
    payoutsTitle: 'Auszahlungen an Eigentümer',
    eligibleDesc: 'Bestätigte Buchungen, die zur Auszahlung bereit sind:',
    payNow: 'Auszahlen',
    scheduled: 'Geplant',
    noPayouts: 'Noch keine Auszahlungen.',
    noData: 'Noch keine Daten.',
    payoutDone: 'Auszahlung veranlasst.',
    payoutError: 'Die Auszahlung konnte nicht veranlasst werden.',
    range7: '7 T',
    range15: '15 T',
    range30: '30 T',
    range90: '90 T',
    range12m: '12 M',
    rangeAll: 'Alle',
    payoutConfirmTitle: 'Auszahlung bestätigen',
    payoutConfirmDesc: 'Auszahlung für Buchung #{{id}} über {{amount}} veranlassen?',
    confirm: 'Bestätigen',
    propertiesNav: 'Kalender',
    propertiesTitle: 'Kalender',
    newProperty: 'Unterkunft hinzufügen',
    editProperty: 'Bearbeiten',
    propertyUntitled: 'Unterkunft ohne Titel',
    propertiesEmpty: 'Sie haben noch keine Unterkunft eingestellt.',
    pendingReviewNote:
      'Neue Unterkünfte bleiben in Prüfung, bis das Team von bitutravel sie freigibt. Sie erhalten eine E-Mail, sobald dies geschehen ist.',
    pendingEditorNote:
      'Diese Unterkunft wird geprüft. Sie können sie weiter bearbeiten; nach der Freigabe erscheint sie in der Suche.',
    unpublished: 'Nicht veröffentlicht',
    photoCount: '{{count}} Fotos',
    noPhotos: 'Keine Fotos',
    unitCount: '{{count}} Einheiten',
    viewCalendar: 'Kalender',
    viewList: 'Liste',
    searchUnits: 'Einheiten suchen…',
    sortName: 'Name',
    sortRecent: 'Neueste',
    chipNeedsPhotos: 'Fotos fehlen',
    stripNoBookings: 'Keine Buchungen in den nächsten 30 Tagen',
    pms: {
      title: 'Belegungsmanager',
      subtitle: 'Buchungen pro Einheit — ziehen zum Verschieben',
      prev: 'Zurück',
      next: 'Weiter',
      today: 'Heute',
      view_month: 'Monat',
      view_week: 'Woche',
      dragHint: 'Ziehe eine Buchung auf eine andere Einheit oder ein anderes Datum, um sie zu verschieben.',
      moved: 'Buchung verschoben',
      moveError: 'Buchung konnte nicht verschoben werden',
      noCity: 'Keine Stadt',
      cities: 'Städte',
      properties: 'Immobilien',
      unit: 'Einheit',
      overall: 'Übersicht',
      allProperties: 'Alle Immobilien',
      noUnits: 'Noch keine Einheiten. Füge eine Immobilie hinzu, um zu beginnen.',
      guest: 'Gast',
      dragHintBlocked: "Click an empty day to block / open it. Drag a booking to move it; drag its right edge to extend or shorten.",
      addBooking: "Add booking",
      dates: 'Daten',
      autoRate: 'Automatischer Tarif',
      applyCustomPrice: 'Benutzerdefinierten Preis anwenden (Rabatt)',
      customPriceHint: 'Bearbeite den Gesamtbetrag, um einen Rabatt zu gewähren. Wird auf die Nächte verteilt.',
      manualBooking: "Manual booking",
      manualBadge: "Manual",
      guestName: "Guest name",
      guestNif: "Guest NIF",
      guests: "Guests",
      pricePerNight: "Preis pro Nacht",
      checkin: "Check-in",
      checkout: "Check-out",
      block: "Block",
      unblock: "Open",
      blocked: "Blocked",
      blockTitle: 'Nacht sperren',
      blockNameLabel: 'Name (optional)',
      blockNamePlaceholder: 'z. B. Wartung',
      blockNameHint: 'Wird am gesperrten Tag angezeigt.',
      blockConfirm: 'Sperren',
      manualCreated: "Manual booking created",
      manualError: "Could not create manual booking",
      notAvailable: "Not available for those dates",
      belowMinStay: "Below the minimum stay for this unit",
      detail: "Booking detail",
      property: "Property",
      nights: "Nights",
      total: "Total",
      iva: "VAT",
      fee: "Platform fee",
      payout: "Payout",
      channel: "Channel",
      status: "Status",
      statusConfirmed: "Confirmed",
      statusActive: "In stay",
      statusPending: "Pending",
      statusAwaiting: "Awaiting payment",
      statusCancelled: "Cancelled",
      channelManual: "Manual",
      channelDirect: "Direct",
      channelIcal: "iCal (importiert)",
      icalNoPayout: "Externe Sperrung — keine Zahlung",
      confirmMove: "Confirm move",
      moveFrom: "From",
      moveTo: "To",
      moveNote: "Availability and price are revalidated on confirm.",
      confirm: "Confirm",
      extendTitle: "Extend stay",
      shortenTitle: "Shorten stay",
      newCheckout: "New check-out",
      extended: "Stay updated",
      extendError: "Could not update the stay",
    },
    products: {
      nav: 'Unterkünfte',
      title: 'Unterkünfte',
      subtitle: 'Tarife und Kanäle pro Einheit. Der Standardtarif wird mit dem Immobilienpreis synchronisiert.',
      empty: 'Du hast noch keine Immobilien.',
      ratePlans: 'Tarife',
      addRatePlan: 'Tarif hinzufügen',
      editRatePlan: 'Tarif bearbeiten',
      ratePlanDesc: 'Ein Tarif ist ein verkaufbares Angebot dieser Einheit (Preis, Reinigung, Mindestaufenthalt).',
      noPlans: 'Noch keine Tarife.',
      planCount: '{{count}} Tarife',
      icalCount: '{{count}} iCal',
      default: 'Standard',
      inactive: 'Inaktiv',
      minNights: 'min. {{count}} Nächte',
      minNightsLabel: 'Mindestnächte',
      feePct: '{{pct}}% Provision',
      feePctLabel: 'bitutravel-Provision (%)',
      feePctPlaceholder: 'Standard',
      feePctHint: 'Leer = globale Provision. 0 = Eigentümerbringe (keine Provision).',
      makeDefault: 'Standardtarif',
      name: 'Name',
      basePrice: 'Grundpreis (NET)',
      cleaningFee: 'Reinigung',
      cancellation: 'Stornierung',
      policy: {
        flexible: 'Flexibel',
        moderate: 'Moderat',
        strict: 'Streng',
      },
      save: 'Speichern',
      cancel: 'Abbrechen',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      confirmDelete: 'Löschen?',
      defaultNoDelete: 'Der Standardtarif kann nicht gelöscht werden.',
      created: 'Tarif erstellt.',
      updated: 'Tarif aktualisiert.',
      deleted: 'Tarif gelöscht.',
      channels: 'Kanäle',
      addChannel: 'Kanal hinzufügen',
      direct: 'Direkt',
      noConnections: 'Keine Verbindungen. Füge einen iCal-Kanal hinzu, um einen externen Kalender zu importieren.',
      icalChannel: 'iCal',
      addIcal: 'iCal-Verbindung hinzufügen',
      icalDesc: 'Füge die iCal-URL eines externen Kalenders ein (Airbnb, Booking, Google…). Belegte Tage blockieren diese Einheit.',
      icalUrl: 'iCal-Kalender-URL',
      addAndSync: 'Hinzufügen & synchronisieren',
      syncNow: 'Synchronisieren',
      syncAll: 'Alle synchronisieren',
      syncDone: '{{upserted}} importiert, {{cancelled}} storniert, {{conflicts}} Konflikte',
      syncAllDone: 'Synchronisierung abgeschlossen: {{upserted}} importiert, {{cancelled}} storniert, {{conflicts}} Konflikte',
      syncError: 'Synchronisierungsfehler',
      lastSync: 'Letzte Synchronisierung',
      neverSynced: 'Noch nicht synchronisiert',
      connectionDeleted: 'Verbindung gelöscht.',
      connStatus: {
        pending: 'Ausstehend',
        active: 'Aktiv',
        paused: 'Pausiert',
        error: 'Fehler',
      },
      rangeActionTitle: 'Zeitraum ausgewählt',
      rangeActionHint: 'Was möchtest du mit diesen Nächten tun?',
      selectHint: 'Klicke auf eine Nacht und dann auf eine weitere (oder zweimal auf dieselbe), um einen Zeitraum zu wählen.',
    },

    status: {
      pending: 'In Prüfung',
      approved: 'Veröffentlicht',
      rejected: 'Abgelehnt',
    },
    step1: 'Grundlagen',
    step2: 'Beschreibung',
    step3: 'Lage & Fotos',
    backStep: 'Zurück',
    nextStep: 'Weiter',
    saveProperty: 'Unterkunft speichern',
    fieldType: 'Unterkunftsart',
    type: {
      apartment: 'Apartment',
      studio: 'Studio',
      house: 'Haus',
      room: 'Zimmer',
      loft: 'Loft',
      duplex: 'Duplex',
      cabin: 'Hütte',
      guesthouse: 'Pension',
      hotel: 'Hotel',
      bed_breakfast: 'Pension mit Frühstück',
    },
    fieldCapacity: 'Kapazität (Gäste)',
    fieldBeds: 'Betten',
    fieldPrice: 'Preis pro Nacht (€)',
    fieldCleaning: 'Reinigungsgebühr (€)',
    fieldCheckinTime: 'Check-in-Zeit',
    fieldCheckoutTime: 'Check-out-Zeit',
    fieldTitleEs: 'Titel (Spanisch)',
    fieldTitleEn: 'Titel (Englisch)',
    fieldDescEs: 'Beschreibung (Spanisch)',
    fieldDescEn: 'Beschreibung (Englisch)',
    fieldCity: 'Stadt',
    fieldCategory: 'Kategorie',
    fieldCategoryHint: 'Executive, Standard, Suite…',
    fieldBuilding: 'Gebäude / Adresse',
    fieldUnitLabel: 'Einheitenbezeichnung',
    fieldNeighborhood: 'Stadtteil / Bezirk',
    fieldNeighborhoodHint: 'z. B. Chamberí',
    fieldPostalCode: 'Postleitzahl',
    cityPrefillNote:
      'Bei der Auswahl einer Stadt füllen wir die Koordinaten mit dem Stadtzentrum; passen Sie sie an, wenn Sie den genauen Standort kennen.',
    photosAfterCreate: 'Speichern Sie zuerst die Unterkunft, dann können Sie Fotos hinzufügen.',
    addPhotos: 'Fotos hinzufügen',
    deletePhoto: 'Foto löschen',
    photoUploadError: 'Das Foto konnte nicht hochgeladen werden.',
    photoDeleteError: 'Das Foto konnte nicht gelöscht werden.',
    createdToast: 'Unterkunft erstellt. Sie befindet sich nun in Prüfung.',
    savedToast: 'Unterkunft gespeichert.',
    saveError: 'Die Unterkunft konnte nicht gespeichert werden.',
    fiscal: {
      title: 'Steuerdaten & VeriFactu',
      subtitle: 'Ausstellerdaten und Vollmacht, damit bitutravel Ihre Rechnungen bei der AEAT einreicht.',
      statusActive: 'VeriFactu aktiv. Ihre Unterkunftsrechnungen werden bei der AEAT eingereicht.',
      statusPending: 'VeriFactu ausstehend. Ihre Rechnungen werden ausgestellt, aber nicht bei der AEAT eingereicht.',
      statusRevoked: 'Ihre Vollmacht wurde widerrufen. Die Einreichung bei der AEAT ist pausiert.',
      active: 'Aktiv',
      pending: 'Ausstehend',
      revoked: 'Widerrufen',
      issuerTitle: 'Ausstellerdaten',
      personaType: 'Personentyp',
      personaF: 'Natürlich',
      personaJ: 'Juristisch',
      seriesLodging: 'Rechnungsserie',
      seriesHint: 'AEAT-Serie für Ihre Unterkunftsrechnungen (Standard O). Nicht ohne Grund ändern.',
      legalName: 'Firmenname / Name',
      nif: 'Steuernr. (NIF)',
      country: 'Land',
      street: 'Adresse',
      postalCode: 'PLZ',
      city: 'Stadt',
      save: 'Steuerdaten speichern',
      saved: 'Steuerdaten gespeichert.',
      saveError: 'Steuerdaten konnten nicht gespeichert werden.',
      errFields: 'Firmenname und NIF sind erforderlich.',
      apoderamientoTitle: 'Vollmacht',
      apoderamientoDesc: 'Um Rechnungen in Ihrem Namen bei der AEAT einzureichen, benötigt bitutravel eine unterschriebene Vertretungsvollmacht. Laden Sie die unterschriebene Vollmacht hoch, um die Einreichung zu aktivieren.',
      poderOnFile: 'Hinterlegte Vollmacht:',
      uploadPoder: 'Unterschriebene Vollmacht hochladen (PDF)',
      poderHint: 'PDF, max. 10 MB.',
      granted: 'Vollmacht aktiviert. VeriFactu reicht Ihre nächsten Rechnungen ein.',
      grantError: 'Vollmacht konnte nicht hinterlegt werden.',
      errPoderSize: 'Die Datei überschreitet 10 MB.',
      legalNote: 'Mit dem Hochladen der Vollmacht bestätigen Sie, die Vertretungsermächtigung unterschrieben zu haben, damit bitutravel Rechnungen bei der AEAT einreicht (RD 1007/2023).',
      bannerPending: 'Aktivieren Sie VeriFactu, um Ihre Rechnungen bei der AEAT einzureichen.',
      bannerRevoked: 'Ihre VeriFactu-Vollmacht ist widerrufen.',
      bannerCta: 'Einrichten',
    },

  },
  profile: {
    title: 'Profil & Einstellungen',
    navProfile: 'Profil',
    accountSection: 'Konto',
    statusLabel: 'Kontostatus',
    rejectionReason: 'Ablehnungsgrund',
    detailsSection: 'Rechnungsdaten',
    languageSection: 'Sprache',
    localeLabel: 'Bevorzugte Sprache',
    localeHint: 'Wird in Ihrem Konto gespeichert und auf allen Ihren Geräten angewendet.',
    localeSaved: 'Sprache aktualisiert.',
    billingSection: 'Abrechnung & Zahlung',
    invoiceEmail: 'Rechnungs-E-Mail',
    invoiceEmailPlaceholder: 'rechnungen@firma.de',
    ibanTransfer: 'IBAN (per Überweisung)',
    ibanHint: 'Wenn Sie per Banküberweisung zahlen möchten.',
    preferredMethod: 'Bevorzugte Zahlungsmethode',
    methodCard: 'Karte',
    methodTransfer: 'Überweisung',
    savedCards: 'Gespeicherte Karten',
    defaultCard: 'Standard',
    billingProcessorNote: 'Kartendaten werden mit Revolut tokenisiert; wir speichern nie die vollständige Nummer.',
    billingSaved: 'Abrechnung aktualisiert.',
  },
  auth: {
    registerTitle: 'Konto erstellen',
    loginTitle: 'Anmelden',
    rolePrompt: 'Wie werden Sie bitutravel nutzen?',
    roleBook: 'Ich buche Unterkünfte',
    roleList: 'Ich biete Unterkünfte an',
    roleCompany: 'Unternehmen',
    roleAutonomo: 'Selbstständig',
    roleOwner: 'Eigentümer',
    roleEmployeeLabel: 'Mitarbeiter',
    roleAgencyLabel: 'Agentur',
    roleCompanyDesc: 'Zentralisierte Reservierungen für Ihr Unternehmen',
    roleAutonomoDesc: 'Für selbstständige Professionals',
    roleOwnerDesc: 'Veröffentlichen und monetarisieren Sie Ihre Unterkünfte',
    roleBookerPrompt: 'Wer bucht?',
    pathManager: 'Ich verwalte Unterkünfte',
    pathManagerDesc: 'Inserieren Sie Ihr Angebot und verwalten Sie Preise und Verfügbarkeit',
    pathBook: 'Ich buche Aufenthalte',
    pathBookDesc: 'Für Unternehmen, Mitarbeitende und Selbstständige',
    roleEmployee: 'Ich arbeite in einem Unternehmen',
    roleEmployeeDesc: 'Ich buche mit der Firmenkarte; die Rechnung geht an das Unternehmen',
    contactName: 'Kontaktperson',
    email: 'E-Mail',
    fullName: 'Vollständiger Name',
    legalName: 'Firmenname',
    cif: 'CIF',
    nif: 'NIF / DNI',
    address: 'Adresse',
    iban: 'IBAN für Auszahlungen',
    irpf: 'IRPF-Quellensteuer (%)',
    submit: 'Antrag senden',
    pendingTitle: 'Antrag wird geprüft',
    pendingDesc: 'Unser Team prüft Ihr Konto. Sie erhalten nach der Freigabe eine E-Mail.',
    pendingApproved: 'Ihr Konto wurde freigegeben!',
    checkStatus: 'Erneut prüfen',
    profileErrorTitle: 'Ihr Profil konnte nicht geladen werden',
    profileErrorDesc:
      'Ihre Sitzung ist gültig, aber wir konnten die Daten Ihres Kontos nicht finden. Versuchen Sie es erneut oder melden Sie sich ab.',
    rejectedTitle: 'Antrag abgelehnt',
    rejectedDesc: 'Ihr Antrag wurde nicht genehmigt. Grund: {{reason}}',
    loginPrompt: 'Schon ein Konto? Anmelden',
    registerPrompt: 'Noch kein Konto? Registrieren',
    login: 'Anmelden',
    magicLink: 'Magischen Link senden',
    magicLinkSent:
      'Wir haben einen magischen Anmeldelink an Ihre E-Mail-Adresse gesendet. Öffnen Sie ihn, um sich anzumelden.',
    cifInvalid: 'Ungültige CIF',
    cifInRegistry: 'Im Unternehmensverzeichnis gefunden',
    nifOrCifInvalid: 'Ungültige NIF/CIF',
    ibanInvalid: 'Ungültige IBAN',
    irpfRange: 'Muss zwischen 7 und 45 % liegen',
    loginErrorGeneric: 'Die Anmeldung ist fehlgeschlagen. Überprüfen Sie die E-Mail-Adresse.',
    loginRateLimited: 'Zu viele Versuche. Bitte warten Sie eine Minute.',
    loginEmailNotConfirmed: 'Bestätigen Sie Ihre E-Mail-Adresse, bevor Sie sich anmelden.',
  },
  admin: {
    approvalsTitle: 'Freigabewarteschlange',
    approve: 'Genehmigen',
    reject: 'Ablehnen',
    reason: 'Grund',
    empty: 'Keine offenen Anträge',
    typeCompany: 'Unternehmen',
    typeAutonomo: 'Selbstständig',
    typeOwner: 'Eigentümer',
    approvedToast: 'Antrag genehmigt',
    rejectedToast: 'Antrag abgelehnt',
    decisionFailed: 'Die Entscheidung konnte nicht gespeichert werden',
    searchPlaceholder: 'Nach Name, E-Mail oder NIF/CIF suchen',
    tabAll: 'Alle',
    tabCompany: 'Unternehmen',
    tabAutonomo: 'Selbstständige',
    tabOwner: 'Eigentümer',
    confirmApprove: '{{name}} genehmigen?',
    confirmReject: '{{name}} ablehnen?',
    confirm: 'Bestätigen',
    reasonRequired: 'Bitte geben Sie einen Ablehnungsgrund an',
    noMatches: 'Keine Treffer',
    roleAdmin: 'Verwaltung',
    consoleTitle: 'Admin-Konsole',
    navApprovals: 'Freigaben',
    navAccounts: 'Konten',
    navBookings: 'Buchungen',
    navInvoices: 'Rechnungen',
    tabAgency: 'Agenturen',
    tabEmployee: 'Mitarbeiter',
    tabBlocked: 'Gesperrt',
    typeAgency: 'Agentur',
    typeEmployee: 'Mitarbeiter',
    typeAdmin: 'Admin',
    typeSuperadmin: 'Superadmin',
    statusPending: 'Ausstehend',
    active: 'Aktiv',
    blocked: 'Gesperrt',
    rejected: 'Abgelehnt',
    block: 'Sperren',
    unblock: 'Entsperren',
    blockedToast: 'Konto gesperrt',
    unblockedToast: 'Konto entsperrt',
    manageFailed: 'Kontostatus konnte nicht geändert werden',
    commissionDefault: 'Standard {{pct}}%',
    commissionEdit: 'Bearbeiten',
    commissionSave: 'Speichern',
    commissionCancel: 'Abbrechen',
    commissionSaved: 'Provision aktualisiert.',
    commissionFailed: 'Provision konnte nicht aktualisiert werden.',
    lastActions: '{{count}} Admin-Aktionen erfasst',
    noBookings: 'Keine Buchungen.',
    noInvoices: 'Keine Rechnungen.',
    kindCommission: 'Provision',
    kindLodging: 'Unterkunft',
    vfFiled: 'VeriFactu eingereicht',
    vfIncidence: 'Vorfall',
    vfPending: 'VeriFactu ausstehend',
    navRegistry: 'Verzeichnis',
    vfSubmit: 'An AEAT senden',
    vfSubmitted: 'An AEAT gesendet',
    vfSubmitFailed: 'AEAT-Übermittlung fehlgeschlagen',
    vfNotConfigured: 'VeriFactu-Zertifikat nicht konfiguriert',
    void: 'Stornieren',
    voidConfirm: 'Diese Rechnung stornieren? Falls sie bei AEAT eingereicht wurde, wird eine Stornierung gesendet.',
    voidDone: 'Rechnung storniert',
    voidFailed: 'Rechnung konnte nicht storniert werden',
    voidAnulacionPending: 'AEAT-Stornierung ausstehend (Zertifikat fehlt)',
    voided: 'Storniert',
    rect: 'Berichtigung',
    rectConfirm: 'Eine Berichtigung ausstellen, die diese Rechnung ersetzt?',
    rectDone: 'Berichtigung ausgestellt',
    rectFailed: 'Berichtigung konnte nicht ausgestellt werden',
    registry: {
      addTitle: 'Unternehmen hinzufügen',
      editTitle: 'Unternehmen bearbeiten',
      listTitle: 'Unternehmensverzeichnis',
      cif: 'CIF',
      legalName: 'Firmenname',
      street: 'Straße',
      postalCode: 'Postleitzahl',
      city: 'Stadt',
      province: 'Provinz',
      country: 'Land',
      save: 'Speichern',
      saved: 'Unternehmen gespeichert',
      saveError: 'Unternehmen konnte nicht gespeichert werden',
      deleted: 'Unternehmen entfernt',
      deleteError: 'Unternehmen konnte nicht entfernt werden',
      errFields: 'CIF und Firmenname sind erforderlich',
      empty: 'Noch keine Unternehmen im Verzeichnis',
      edit: 'Bearbeiten',
    },
  },
  dashboard: {
    roleLabel: 'Rolle',
    emailLabel: 'E-Mail',
  },
  notFound: {
    title: 'Seite nicht gefunden',
    desc: 'Die gesuchte Seite existiert nicht oder wurde verschoben.',
  },
  error: {
    boundaryDesc: 'Etwas ist schiefgelaufen. Laden Sie neu, um fortzufahren.',
    boundaryReload: 'Neu laden',
  },
  common: {
    loading: 'Laden…',
    error: 'Etwas ist schiefgelaufen',
    favorite: 'Zu Favoriten speichern',
    required: 'Erforderlich',
    back: 'Zurück',
    retry: 'Erneut versuchen',
    continue: 'Fortfahren',
    done: 'Fertig',
    save: 'Speichern',
    plusIva: '+ MwSt.',
    cancel: 'Abbrechen',
    rooms: 'Schlafzimmer',
    room: 'Schlafzimmer',
    bathrooms: 'Badezimmer',
    bathroom: 'Badezimmer',
    increment: 'Erhöhen',
    decrement: 'Verringern',
    edit: 'Bearbeiten',
    close: "Schließen",
    previous: 'Zurück',
    next: 'Weiter',
  },
  amenities: {
    wifi: 'WLAN',
    parking: 'Parkplatz',
    ac: 'Klimaanlage',
    heating: 'Heizung',
    washing: 'Waschmaschine',
    dishwasher: 'Geschirrspüler',
    elevator: 'Aufzug',
    furnished: 'Möbliert',
    kitchen: 'Küche',
    meeting_room: 'Besprechungsraum',
    printer: 'Drucker',
    gym: 'Fitnessraum',
  },
} as const